// extracted by mini-css-extract-plugin
module.exports = {"TabNavContentWrapper":"TabNavContentWrapper___3Rov7","TabNavContentWrapper__noPadding":"TabNavContentWrapper__noPadding___Ra-gK","TabNavLabelWrapper":"TabNavLabelWrapper___38aHZ"};